import { createFileRoute } from "@tanstack/react-router";
import { EvaluatorPage } from "./-evaluator/evaluator.page";

export const Route = createFileRoute("/content/evaluator/")({
  component: EvaluatorPage,
});
